import React from "react";
import { useNavigate } from "react-router-dom";
import {
  RankingProducaoProvider,
  useRankingProducao,
} from "./context/RankingProducaoContext";
import { RankingProducaoView } from "./components/RankingProducaoView";

const RankingProducaoContent: React.FC = () => {
  const navigate = useNavigate();
  const {
    pizzaiolos,
    dailyStats,
    lojas,
    isLoading,
    selectedLojaId,
    showLojaSelector,
    dateLabel,
    selectedLojaNome,
    toggleLojaSelector,
    selectAllLojas,
    selectLoja,
  } = useRankingProducao();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center bg-red-900 text-white">
        <div className="text-center">
          <p className="text-xl">Carregando ranking...</p>
        </div>
      </div>
    );
  }

  return (
    <RankingProducaoView
      pizzaiolos={pizzaiolos}
      dailyStats={dailyStats}
      lojas={lojas}
      selectedLojaId={selectedLojaId}
      showLojaSelector={showLojaSelector}
      dateLabel={dateLabel}
      selectedLojaNome={selectedLojaNome}
      onGoHome={() => navigate("/dashboard")}
      onToggleLojaSelector={toggleLojaSelector}
      onSelectAllLojas={selectAllLojas}
      onSelectLoja={selectLoja}
    />
  );
};

const RankingProducaoPage: React.FC = () => {
  return (
    <RankingProducaoProvider>
      <RankingProducaoContent />
    </RankingProducaoProvider>
  );
};

export default RankingProducaoPage;
export { RankingProducaoView } from "./components/RankingProducaoView";
export type { RankingProducaoViewProps } from "./types";
